import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets a custom shipping method (independent of the `}<a parentName="p" {...{
          "href": "/api/../api/projects/shippingMethods#shippingmethod"
        }}>{`ShippingMethods`}</a>{` defined in the project). The custom shipping method can be unset with the `}<inlineCode parentName="p">{`setShippingMethod`}</inlineCode>{` action without the `}<inlineCode parentName="p">{`shippingMethod`}</inlineCode>{`. `}<strong parentName="p">{`Prerequisite:`}</strong>{` The cart must contain a shipping address.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setCustomShippingMethod"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingMethodName`}</inlineCode>{` - String - Required`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingRate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/shippingMethods#shippingratedraft"
          }}>{`ShippingRateDraft`}</a>{` - Required`}<br parentName="li"></br>
          {`The shipping rate used to determine the price.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`taxCategory`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/taxCategories#taxcategory"
          }}>{`TaxCategory`}</a>{` - Optional`}<br parentName="li"></br>
          {`The given tax category will be used to select a tax rate when a cart has the `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxmode"
          }}>{`TaxMode`}</a>{` `}<inlineCode parentName="li">{`Platform`}</inlineCode>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTaxRate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externaltaxratedraft"
          }}>{`ExternalTaxRateDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`An external tax rate can be set if the cart has the `}<inlineCode parentName="li">{`External`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxmode"
          }}>{`TaxMode`}</a>{`.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      